import React, { useMemo } from "react";
import { StyleSheet, View } from "react-native";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import LHSectionHeader from "../../components/LHSectionHeader";
import LHMiscellaneousObservations from "../../components/LHMiscellaneousObservations.fixed.new";
import MaterialIcons from "react-native-vector-icons/MaterialIcons";
import { useTheme } from "../../theme";
import type { ThemeColors } from "../../theme/types";

const createStyles = (colors: ThemeColors) =>
  StyleSheet.create({
    cardContainer: {
      marginBottom: 24,
      borderRadius: 6,
      overflow: 'hidden',
      elevation: 4,
      shadowColor: 'rgba(0, 94, 192, 0.08)',
      shadowOffset: {
        width: 4,
        height: 0,
      },
      shadowOpacity: 1,
      shadowRadius: 24,
    },
    sectionHeader: {
      borderTopLeftRadius: 6,
      borderTopRightRadius: 6,
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
    },
    header1text: {
      fontSize: 16,
    },
    contentContainer: {
      borderBottomLeftRadius: 6,
      borderBottomRightRadius: 6,
      backgroundColor: colors.background.surface,
      borderWidth: 1,
      borderTopWidth: 0,
      borderColor: colors.border.default,
    },
  });

const PulseCheckMiscellaneousObservations: React.FC = () => {
  const { colors } = useTheme();
  const styles = useMemo(() => createStyles(colors), [colors]);
  const pulseState = useSelector(
    (state: RootState) => state.pulseCheck.pulseState
  );

  // Also consider selected observation/record status when determining read-only mode
  const selectedObservation = useSelector(
    (state: RootState) => state.observation.selectedObservation
  );
  const selectedRecord = useSelector(
    (state: RootState) => state.pulseCheck.selectedRecord
  );

  const isCompleted =
    pulseState === "completed" ||
    selectedObservation?.status === "completed" ||
    selectedRecord?.status === "completed" ||
    (selectedRecord?.action &&
      String(selectedRecord.action).toLowerCase() === "completed");

  return (
    <View style={styles.cardContainer}>
      <LHSectionHeader
        title="Miscellaneous Observations"
        containerStyle={styles.sectionHeader}
        textStyle={styles.header1text}
      />
      <View style={styles.contentContainer}>
        <LHMiscellaneousObservations
          disabled={Boolean(isCompleted)}
          containerName="observations"
        />
      </View>
    </View>
  );
};

export default PulseCheckMiscellaneousObservations;
